export default "__VITE_ASSET__CjEZGsQe__"